import React from 'react';

import 'css/components/www/_Quotes.scss';
import { P } from 'common/ui/Text';
import nbspLastSpace from 'common/util/nbspLastSpace';

type Props = {
  header: React.ReactNode | string;
  text: React.ReactNode | string;
  person: React.ReactNode;
};
const Quote = ({ header, text, person }: Props) => {
  const adjustedHeader = typeof header === 'string' ? nbspLastSpace(header) : header;
  const adjustedText = typeof text === 'string' ? nbspLastSpace(text) : text;

  return (
    <div className="quote">
      <div className="quoteWrapper">
        <P className="quoteHeading" variant="bodyMd" fontWeight="bold">
          {adjustedHeader}
        </P>
        <P className="quoteText" variant="bodyLg">
          “{adjustedText}“
        </P>
      </div>
      {person}
    </div>
  );
};

export default Quote;
